import { createReducer } from 'redux-act';

import {
  WEB_MENUS_FETCH, WEB_MENUS_FETCH_DATA_SUCCESS, WEB_MENUS_FETCH_DATA_FAIL,
  WEB_MENUS_DELETE_INIT, WEB_MENUS_DELETE_SUCCESS, WEB_MENUS_DELETE_FAIL,
  WEB_MENUS_CREATE_INIT, WEB_MENUS_CREATE_SUCCESS, WEB_MENUS_CREATE_FAIL,
  WEB_MENUS_MODIFY_INIT, WEB_MENUS_MODIFY_SUCCESS, WEB_MENUS_MODIFY_FAIL,
  WEB_MENUS_CLEAN_UP, WEB_MENUS_CLEAR_DATA_LOGOUT,
} from 'state/actions/webMenus';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webMenusReducer = createReducer(
  {
    [WEB_MENUS_FETCH]: (state) => ({ ...state, loading: true, error: null }),
    [WEB_MENUS_FETCH_DATA_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false }),
    [WEB_MENUS_FETCH_DATA_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [WEB_MENUS_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [WEB_MENUS_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: [...state.list, payload.menu], loading: false, success: true }),
    [WEB_MENUS_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [WEB_MENUS_MODIFY_INIT]: (state) => ({ ...state, loading: true, updated: false }),
    [WEB_MENUS_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.id ? payload.menu : item),
      loading: false, updated: true,
    }),
    [WEB_MENUS_MODIFY_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, updated: false }),
    [WEB_MENUS_DELETE_INIT]: (state) => ({ ...state, loading: true, deleted: false }),
    [WEB_MENUS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, deleted: true,
    }),
    [WEB_MENUS_DELETE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, deleted: false }),
    [WEB_MENUS_CLEAN_UP]: (state) => ({ ...state, loading: false, error: null, success: false, deleted: false, updated: false }),
    [WEB_MENUS_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
  },
  initialState
);
